module.exports = __webpack_public_path__ + "img/sites.83ce2b52.png";